import { jsx } from 'react/jsx-runtime';
import { createContext, Tooltip, Text } from '@flex-design-system/fx';
import { isEllipsisActive } from '@flex-design-system/fx-utils/element';
import { styled } from '@flex-design-system/stitches-react';
import { useComposedRefs } from '@radix-ui/react-compose-refs';
import { forwardRef, useRef, useEffect, useState } from 'react';

const [TextContextProvider, useTextContext] = createContext("OverflowTextTooltip");
const OverflowTextTooltip = ({
  children,
  tolerance,
  ...props
}) => {
  const [textElement, setTextElement] = useState(null);
  const [textContent, setTextContent] = useState();
  const isTruncated = textElement !== null && isEllipsisActive(textElement, tolerance);
  return /* @__PURE__ */ jsx(
    TextContextProvider,
    {
      isTruncated,
      textElement,
      onChangeTextElement: setTextElement,
      textContent,
      onChangeTextContent: setTextContent,
      children: /* @__PURE__ */ jsx(Tooltip, { ...isTruncated ? {} : { open: false }, ...props, children })
    }
  );
};
const TargetText = forwardRef(
  ({ children, ellipsis = true, ...props }, ref) => {
    const { isTruncated, onChangeTextElement, onChangeTextContent } = useTextContext("OverflowTextTooltip/Text");
    const textRef = useRef(null);
    const textElement = textRef.current;
    const composedRefs = useComposedRefs(ref, textRef);
    useEffect(() => {
      onChangeTextElement(textElement);
    }, [onChangeTextElement, textElement]);
    useEffect(() => {
      onChangeTextContent(children);
    }, [onChangeTextContent, children]);
    return /* @__PURE__ */ jsx(
      StyledText,
      {
        ...props,
        ref: composedRefs,
        ellipsis,
        tabIndex: props.tabIndex ?? (isTruncated ? 0 : void 0),
        children
      }
    );
  }
);
const Content = forwardRef(
  ({ children, ...props }, ref) => {
    const { textContent } = useTextContext("OverflowTextTooltip/Content");
    return /* @__PURE__ */ jsx(Tooltip.Content, { ...props, ref, children: typeof children === "function" ? children(textContent) : textContent });
  }
);
const StyledText = styled(Text, {
  focusVisible: {
    focusStyle: "outline",
    outline: "none"
  }
});
OverflowTextTooltip.Trigger = Tooltip.Trigger;
OverflowTextTooltip.Text = TargetText;
OverflowTextTooltip.Content = Content;

export { OverflowTextTooltip as default };
//# sourceMappingURL=OverflowTextTooltip.mjs.map
